// 定义每个域名下完整的配置结构
interface OriginConfigItem {
    name: string
    logo: {
        top: string
        bottom: string
        modal: string
        login: string
    }
    // 将请求域名和CP订单域名也纳入配置
    apiUrl: string
    testApiUrl: string
    policyLinks: string
    isShowBottomMsg: boolean
}

// 公司前缀
const prefix = 'mr'

// 根据域名区分的全量配置（包含测试/生产环境的差异）
const originConfig: Record<string, OriginConfigItem> = {
    'https://checkout.newlinkgames.com': {
        name: 'new link games',
        logo: {
            top: require('@/assets/img/checkout.newlinkgames.com/logo/top.png'),
            bottom: require('@/assets/img/checkout.newlinkgames.com/logo/bottom.png'),
            modal: require('@/assets/img/checkout.newlinkgames.com/logo/modal.png'),
            login: require('@/assets/img/checkout.newlinkgames.com/logo/login.png'),
        },
        apiUrl: 'https://api.newlinkgames.com',
        testApiUrl: `https://api-dev.newlinkgames.com`,
        policyLinks: 'https://newlinkgames.com/payOtherPage/',
        isShowBottomMsg: true,
    },
    'https://checkout.livenplay.net': {
        name: 'liven play games',
        logo: {
            top: '',
            bottom: '',
            modal: '',
            login: '',
        },
        apiUrl: 'https://api.livenplay.net',
        testApiUrl: `https://api-dev.livenplay.net`,
        policyLinks: 'https://livenplay.net/payOtherPage/',
        isShowBottomMsg: false,
    },
    'https://checkout.playdrive.net': {
        name: 'play drive games',
        logo: {
            top: '',
            bottom: '',
            modal: '',
            login: '',
        },
        apiUrl: 'https://api.playdrive.net',
        testApiUrl: `https://api-dev.playdrive.net`,
        policyLinks: 'https://playdrive.net/payOtherPage/',
        isShowBottomMsg: false,
    },
}

// 获取当前域名配置，如果没有匹配到，则默认使用 newlinkgames 的生产配置
const currentOrigin = window.location.origin
const originObj = originConfig[currentOrigin] || originConfig['https://checkout.newlinkgames.com']
const isShowBottomMsg = originObj.isShowBottomMsg

// 根据 NODE_ENV 决定最终导出的变量
let comUrl = ''
let policyLinks = originObj.policyLinks

switch (process.env.VUE_APP_ENV) {
    case 'production':
        // 生产或测试环境：直接使用当前域名配置表里的地址
        comUrl = originObj.apiUrl
        break;
    case 'test': //测试环境
        comUrl = originObj.testApiUrl
        break;
    default:
        // 本地开发环境：走本地 proxy 代理
        comUrl = '/replaceUrl'
        break;
}

export {
    comUrl,          // 请求域名
    policyLinks, // 服务协议 隐私政策 退款政策 域名
    prefix,          // 公司前缀
    originObj,        // 当前域名的完整配置对象（包含 name, logo 等）
    isShowBottomMsg
}
